export default __webpack_public_path__ + "static/media/JasonShah.841ae84c.jpeg";